import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM6.375 7.5C6.375 7.15482 6.65482 6.875 7 6.875H8C8.34518 6.875 8.625 7.15482 8.625 7.5V10.875H9.5C9.84518 10.875 10.125 11.1548 10.125 11.5C10.125 11.8452 9.84518 12.125 9.5 12.125H8H6.5C6.15482 12.125 5.875 11.8452 5.875 11.5C5.875 11.1548 6.15482 10.875 6.5 10.875H7.375V8.125H7C6.65482 8.125 6.375 7.84518 6.375 7.5ZM8 5.5C8.41421 5.5 8.75 5.16421 8.75 4.75C8.75 4.33579 8.41421 4 8 4C7.58579 4 7.25 4.33579 7.25 4.75C7.25 5.16421 7.58579 5.5 8 5.5Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
